import { Icon, type Icons, Span } from "@virtual-brain-lib/frontend-design-system/ui";
import type { MessageToolStatus } from "@virtual-brain-lib/types";

interface ToolCardHeaderProps {
	readonly icon: Icons;
	readonly title: string;
	readonly status: MessageToolStatus;
	readonly subtitle?: string;
	readonly trailingIcon?: Icons;
	readonly statusIcon?: Icons;
}

export function ToolCardHeader({
	icon,
	title,
	status,
	subtitle,
	trailingIcon,
	statusIcon,
}: ToolCardHeaderProps) {
	const defaultStatusIcon = status === "processing" ? "spinner" : "circleCheck";

	return (
		<div className="flex items-center justify-between gap-2">
			<div className="flex min-w-0 items-center gap-1.5">
				<Icon color="defaultLight" name={icon} size="sm" />
				<Span className="truncate font-medium" color="default" variant="body-xs">
					{title}
				</Span>
				{subtitle && (
					<>
						<Span color="defaultLight" variant="body-xs">
							·
						</Span>
						<Span className="truncate" color="defaultLight" variant="body-xs">
							{subtitle}
						</Span>
					</>
				)}
			</div>
			<div className="flex shrink-0 items-center gap-1">
				<span className="flex size-3 shrink-0 items-center justify-center">
					<Icon color="defaultLight" name={statusIcon ?? defaultStatusIcon} size="sm" />
				</span>
				{trailingIcon && (
					<span className="flex size-3 shrink-0 items-center justify-center">
						<Icon color="defaultLight" name={trailingIcon} size="sm" />
					</span>
				)}
			</div>
		</div>
	);
}
